/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { QRCodeCanvas } from 'qrcode.react'; // install via: npm install qrcode.react

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";
import SoftButton from "components/SoftButton";
import ReceiptDialog from "components/Dialogs/ReceiptDialog";
import ReceiptCodeDialog from "components/Dialogs/ReceiptCodeDialog";

function Author({ name, username, email }) {
  return (
    <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar
          src={`https://ui-avatars.com/api/?name=${name}`}
          alt={name}
          size="sm"
          variant="rounded"
        />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column">
        <SoftTypography variant="button" fontWeight="medium">
          {name} ({username})
        </SoftTypography>
        <SoftTypography variant="caption" color="secondary">
          {email}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

function Function({ job, org }) {
  return (
    <SoftBox display="flex" flexDirection="column">
      <SoftTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </SoftTypography>
      <SoftTypography variant="caption" color="secondary">
        {org}
      </SoftTypography>
    </SoftBox>
  );
}

const apiUrl = "https://api.getverceipt.com/api/v1";

function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default function usePendingReceiptTableData() {
  const [rows2, setRows] = useState([]);
  const [loading2, setLoading] = useState(true);

  const columns2 = [
    { name: "id", align: "center" },
    { name: "store", align: "left" },
    { name: "issued", align: "center" },
    { name: "action", align: "center" }
  ];

  const [maxStores2, setMaxStores] = useState(0);
  const [storeCount2, setStoreCount] = useState(0);
  const [viewingReceipt, setViewingReceipt] = useState(null);
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [receiptCode, setReceiptCode] = useState('');
  const [receiptUuid, setReceiptUuid] = useState('');
  const [storeAddress, setStoreAddress] = useState('');
  const [receiptCount, setReceiptCount] = useState(0);

  const onViewReceipt = async (receipt) => {
    setViewingReceipt(receipt.receipt_data);
    setReceiptOpen(true);
    setReceiptCode(receipt.code);
    setReceiptUuid(receipt.uuid);
  }

  useEffect(() => {
    const terminalId = "test"; // TODO: amend this
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/receipts/list/unclaimed/by-store`, {
          method: 'GET',
          withCredentials: true,
          credentials: 'include', // make sure cookies/session are sent
          headers: {
            'Content-Type': 'application/json',
          },
        });        
        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();
        console.log("unclaimed", data)

        const formattedRows = data.map((user) => ({
          id: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.id}</SoftTypography>,
          store: <SoftTypography variant="caption" color="secondary" fontWeight="medium">{user.address} (id: {user.store_id})</SoftTypography>,
          issued: (
            <SoftTypography variant="caption" color="secondary" fontWeight="medium">
              {formatDate(user.issued_at)}
            </SoftTypography>
          ),
          action: (
            <SoftTypography
              component="a"
              href="#"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              onClick={() => onViewReceipt(user)}
            >
              View
            </SoftTypography>
          ),
        }));

        setRows(formattedRows);
      } catch (error) {
        console.error("Failed to fetch pending receipts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const viewReceiptDialog2 = (
      <ReceiptCodeDialog
        open={receiptOpen}
        onClose={() => setReceiptOpen(false)}
        data={viewingReceipt}
        code={receiptCode}
        uuid={receiptUuid}
      />
  );

  return { columns2, rows2, loading2, receiptCount, storeAddress, viewReceiptDialog2 };
}
